import * as React from 'react';

function Link(props) {
	return (
		<svg
			aria-label={`link icon`}
			width={'23'}
			height={'23'}
			viewBox={'0 0 23 23'}
			fill={'none'}
			xmlns={'http://www.w3.org/2000/svg'}
			{...props}
		>
			<title>link icon</title>
			<path d={'M15.1263 17.9279L13.6144 16.416L11.0584 18.972C10.1584 19.872 9.00649 20.34 7.74643 20.34C6.48637 20.34 5.33449 19.836 4.43443 18.972C3.53443 18.072 3.06637 16.92 3.06637 15.66C3.06637 14.3999 3.5704 13.248 4.43443 12.348L6.9904 9.792L5.47846 8.28006L2.92249 10.836C1.62652 12.132 0.906522 13.86 0.906522 15.66C0.906521 17.496 1.62652 19.188 2.92249 20.484C4.21846 21.78 5.94649 22.5 7.74649 22.5C9.54649 22.5 11.2745 21.78 12.5705 20.484L15.1263 17.9279Z'} fill={'#A4A4A4'} />
			<path d={'M20.5623 7.48795C20.5623 8.74795 20.0583 9.89989 19.1943 10.7999L16.6383 13.3559L18.1502 14.8679L20.7062 12.3119C22.0022 11.0159 22.7222 9.28789 22.7222 7.48789C22.7222 5.65192 22.0022 3.95989 20.7062 2.66389C19.4102 1.36792 17.6822 0.647918 15.8822 0.647918C14.0822 0.647918 12.3542 1.36792 11.0582 2.66389L8.50223 5.21986L10.0142 6.7318L12.5701 4.17583C13.4701 3.27583 14.6221 2.80777 15.8821 2.80777C17.1422 2.80777 18.2941 3.3118 19.1941 4.17583C20.0944 5.0401 20.5624 6.22801 20.5624 7.48813L20.5623 7.48795Z'} fill={'#A4A4A4'} />
			<path d={'M14.1058 7.73724L15.6331 9.26454L9.52386 15.3737L7.99656 13.8464L14.1058 7.73724Z'} fill={'#A4A4A4'} />
		</svg>
	);
}

export default Link;
